import { useState, useEffect } from 'react';
import { Network } from '@capacitor/network';

/**
 * Hook to monitor network status
 * @returns {Object} { isOnline, connectionType, loading }
 */
const useNetworkStatus = () => {
  const [isOnline, setIsOnline] = useState(true);
  const [connectionType, setConnectionType] = useState('unknown');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const getNetworkStatus = async () => {
      try {
        setLoading(true);
        const status = await Network.getStatus();
        setIsOnline(status.connected);
        setConnectionType(status.connectionType);
      } catch (error) {
        console.error('Failed to get network status:', error);
        setIsOnline(false);
        setConnectionType('unknown');
      } finally {
        setLoading(false);
      }
    };

    getNetworkStatus();

    const handleNetworkChange = (status) => {
      setIsOnline(status.connected);
      setConnectionType(status.connectionType);
    };

    // Add listener for network changes
    Network.addListener('networkStatusChange', handleNetworkChange);

    return () => {
      // Cleanup listener
      Network.removeAllListeners();
    };
  }, []);

  return { isOnline, connectionType, loading };
};

export default useNetworkStatus;
